export const getNameLikeCondition = (input?: string) => ({
  like: input ? `%${input.replace(/([., _-]+)/gi, '%')}%` : '',
});

export const getStringSearchCondition = (field: string, value: string) =>
  field.endsWith('.name') ||
  field.endsWith('Name') ||
  field === 'name' ||
  field === 'location' ||
  field.endsWith('.street1') ||
  field.endsWith('.street2')
    ? {
        [field]: getNameLikeCondition(value),
      }
    : {
        [field]: {
          startsWith: value,
        },
      };

type SearchField = { field: string };
type SearchFields<T extends SearchField = SearchField> = Array<T>;

type SearchFieldLabel = { label?: string | null };

export const getStringSearchPlaceholder = (
  fields: SearchFieldLabel[] | Readonly<SearchFieldLabel[]>
): string =>
  fields
    .filter((field) => !!field.label)
    .map((field: SearchFieldLabel) => field.label)
    .join(' ')
    .toLowerCase();

export const getStringSearchOr = (
  fields: SearchFields | Readonly<SearchFields>,
  value?: string
) =>
  value && value.length > 1
    ? fields.map((field) => getStringSearchCondition(field.field, value))
    : undefined;
